import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import mutations from "./mutations";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    change: false, //页面loding
    isLogin: false, //是否登陆
    classifyId: {
      //nav ID
      categoryName: "",
      id: "",
    },
    headerName: "医学V视界",
    vux: {
      isLoading: false,
    },
    showCover: false, //规则
    /*
     * @params ${show} true 显示
     * @params ${type} 1规则 2重要提示 3 提现成功 4需要完善信息 5 每天最多领取5个红包 6 分享红包没有抢到 7 获得分享红包
     * */
    popup: { show: false, type: 1 },
    wxUserInfo: {},
    courseVideUrl: "",
    flowerCount: 0,
    hasUserRevice: true, // 是否使用过复活卡-二期  false 没有机会
  },
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js